export default __webpack_public_path__ + "static/media/ceremonia.7e1a33e4.svg";